export const contactsData = {
    email: 'SubhashniJha80@gmail.com',
    phone: '8829814175',
    address: 'Cyber Hub, Gurgaon, Haryana ',
    github: '#',
    youtube: '#',
    linkedIn: '#',
    twitter: '#',
    medium: '#',
    stackOverflow: '#',
    devUsername: "#"
}